"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_otp_input_1 = require("react-otp-input");
const react_1 = require("react");
const material_1 = require("@mui/material");
const OtpV2_style_1 = require("./OtpV2.style");
const OtpInputV2 = (_a) => {
    var { onChange, error } = _a, rest = __rest(_a, ["onChange", "error"]);
    const { container } = (0, OtpV2_style_1.default)(error);
    const [value, setValue] = (0, react_1.useState)('');
    const handleChange = (otp) => {
        setValue(otp);
        onChange(otp);
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: container, children: (0, jsx_runtime_1.jsx)(react_otp_input_1.default, Object.assign({ value: value, shouldAutoFocus: true, onChange: handleChange, renderSeparator: (0, jsx_runtime_1.jsx)("span", { style: { width: '12px' } }), renderInput: (props, index) => ((0, jsx_runtime_1.jsx)("input", Object.assign({}, props, (index === 0 ? { autoComplete: 'one-time-code' } : {})))) }, rest)) }));
};
exports.default = OtpInputV2;
